import React, { useState } from 'react';

import searchIcon from '../../../assets/images/search_icon.png';
import down_arrow from '../../../assets/images/down_arrow.png';

const SearchKeyword = ({
  onSearch,
  placeholder = '검색어를 입력하세요',
  filterOptions = [
    { value: 'all', label: '제목' },
    { value: 'title', label: '내용' },
    { value: 'content', label: '제목+내용' },
  ],
  initialFilter = 'all',
  initialKeyword = '',
}) => {
  const [selectedFilter, setSelectedFilter] = useState(initialFilter);
  const [keyword, setKeyword] = useState(initialKeyword);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleSearch = () => {
    if (onSearch) {
      onSearch({
        filter: selectedFilter,
        keyword: keyword.trim(),
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleFilterSelect = (option) => {
    setSelectedFilter(option.value);
    setIsDropdownOpen(false);
  };

  const getSelectedFilterLabel = () => {
    const selected = filterOptions.find(
      (option) => option.value === selectedFilter
    );
    return selected ? selected.label : filterOptions[0].label;
  };

  return (
    <div className="center">
      <div className="search-keyword-container w-100 flex justify-end align-end">
        <div className="search_wrapper row-flex-center gap-10 ml-auto">
          <div className="filter_dropdown pointer w-25">
            <button
              className="filter_button w-100 "
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              type="button"
            >
              {getSelectedFilterLabel()}
              <span
                className={`dropdown_arrow ${isDropdownOpen ? 
                  'open' : ''} ml-33` }
              >
                <img src={down_arrow} alt="" />
              </span>
            </button>

            {isDropdownOpen && (
              <div className="dropdown_menu prt-light fs-16 ">
                {filterOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`dropdown_item ${
                      selectedFilter === option.value ? 
                      'selected' : ''
                    }`}
                    onClick={() => handleFilterSelect(option)}
                    type="button"
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="search_input_wrapper row-flex-center w-70">
            <input
              type="text"
              className="search_input"
              placeholder={placeholder}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button
              className="search_button"
              onClick={handleSearch}
              type="button"
            >
              <img src={searchIcon} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchKeyword;
